import posthog from 'posthog-js';

const posthogProjectToken = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST;

const CONSENT_KEY = 'cookie_consent';

export type CookieConsent = 'accepted' | 'rejected';

if (!posthogProjectToken) {
    if (import.meta.env.DEV) {
        throw new Error(
            'VITE_POSTHOG_PROJECT_TOKEN variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once VITE_POSTHOG_PROJECT_TOKEN is configured',
        );
    }
} else if (!posthogHost) {
    if (import.meta.env.DEV) {
        throw new Error(
            'VITE_POSTHOG_HOST variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once VITE_POSTHOG_HOST is configured',
        );
    }
}

function initPostHog() {
    if (!posthogProjectToken || !posthogHost) return;
    posthog.init(posthogProjectToken, {
        api_host: posthogHost,
        defaults: '2026-05-30',
        capture_exceptions: {
            capture_unhandled_errors: true,
            capture_unhandled_rejections: true,
            capture_console_errors: false,
        },
    });
}

export function getCookieConsent(): CookieConsent | null {
    const consent = localStorage.getItem(CONSENT_KEY);
    return consent === 'accepted' || consent === 'rejected' ? consent : null;
}

export function setCookieConsent(consent: CookieConsent) {
    localStorage.setItem(CONSENT_KEY, consent);
    if (consent === 'accepted') initPostHog();
}

if (getCookieConsent() === 'accepted') initPostHog();

export default posthog;
